import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { LaerdalLogo, LaerdalWhiteLogo } from '../assets';
import {BREAKPOINTS, COLORS, ComponentTextStyle, focusStyles, invertedFocusStyles} from '../styles';
import { ComponentMStyling, ComponentXSStyling } from '../styles';
import {defaultOnMouseDownHandler} from '../common';

const StyledLink = styled(Link)<{ $color?: string }>`
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  &:focus-within {
    outline: none;
  }
  svg {
    width: 66px;
    height: 36px;
    color: ${(props) => props.$color};
    ${BREAKPOINTS.MEDIUM} {
      width: 88px;
      height: 48px;
    }
  }
`;

const LogoContainer = styled.div`
  display: flex;
  max-width: calc(100% - 48px);
  overflow: hidden;
  align-items: center;
  height: 40px;
  box-sizing: border-box;
  padding: 24px 0;

  ${BREAKPOINTS.LARGE} {
    margin-top: 8px;
    margin-bottom: 7px;
  }

  &:focus-within {
    ${focusStyles}
  }

  &.inverted:focus-within {
    ${invertedFocusStyles}
  }
`;

const Name = styled.span<{ $color?: string; noSizeChangeOnMobile: boolean }>`
  margin-left: 8px;
  padding-left: 8px;
  border-left: 1px solid ${(props) => props.$color || COLORS.black};
  letter-spacing: -0.02em;
  max-width: 200px;
  
  white-space: nowrap;
  overflow: hidden;

  ${(props) =>
    props.noSizeChangeOnMobile
      ? ComponentMStyling(ComponentTextStyle.Regular, props.$color || COLORS.black)
      : ComponentXSStyling(ComponentTextStyle.Regular, props.$color || COLORS.black)}

  font-weight: 300 !important;
  line-height: 24px !important;

  ${BREAKPOINTS.MEDIUM} {
    ${(props) => ComponentMStyling(ComponentTextStyle.Regular, props.$color || COLORS.black)};
  }

  ${BREAKPOINTS.LARGE} {
    margin-left: 12px;
    padding-left: 12px;
  }
`;

const BetaTag = styled.span<{ backgroundColor?: string; $color?: string }>`
  background-color: ${(props) => props.backgroundColor || COLORS.accent2_500};
  padding: 4px 8px;
  margin-left: 8px;
  margin-top: 2px;
  border-left: none;
  border-radius: 2px;

  ${(props) => ComponentXSStyling(ComponentTextStyle.UppercaseBold, props.$color || COLORS.white)}
`;

type LogoProps = {
  name: string;
  showBetaTag?: boolean;
  onClick?: () => void;
  to?: string;
  color?: string;
  noSizeChangeOnMobile?: boolean;
  betaTagBackgroundColor?: string;
  betaTagColor?: string;
  inverted?: boolean;
};

const Logo = ({ name, showBetaTag, onClick, to, color, noSizeChangeOnMobile, betaTagBackgroundColor, betaTagColor, inverted }: LogoProps): React.ReactElement<LogoProps> => {
  return (
    <LogoContainer className={inverted ? 'inverted' : ''}>
      <StyledLink
        to={to || '/'}
        onMouseDown={defaultOnMouseDownHandler}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
        $color={color}>
        {color === COLORS.white ? <LaerdalWhiteLogo /> : <LaerdalLogo />}
        <Name $color={color} noSizeChangeOnMobile={noSizeChangeOnMobile || false}>
          {name}
        </Name>
        {showBetaTag && (
          <BetaTag backgroundColor={betaTagBackgroundColor} $color={betaTagColor}>
            BETA
          </BetaTag>
        )}
      </StyledLink>
    </LogoContainer>
  );
};

export default Logo;
